<template>
  <div class="related-brand" v-if="pageItems.length">
    <strong class="cxStrong">
      <a :href="titleUrl" target="_blank" @click="countAd(4187)"><em>{{$global.q}}</em>【相关品牌】</a>
    </strong>
    <el-carousel :height="carouselHeight" :autoplay="false" :indicator-position="isShowIndicator" :arrow="isShowToggle">
      <el-carousel-item class="swipe-list" v-for="(page, count) in pageItems" :key="count">
        <div class="cell" v-for="(item, index) in page.items" :key="index">
          <div class="cell-l">
            <a :href="toBrandSeriesInfo(item)" target="_blank">
              <img class="logo" :src="item.logo || defaultLogoImage" alt="">
            </a>
            <div class="content">
              <a :href="toBrandSeriesInfo(item)" target="_blank" class="name">{{item.name}}</a>
              <div class="inner-wrap">
                <div class="desc">{{item.text}}</div>
                <a :href="item.baiKeUrl" v-if="item.baiKeUrl" target="_blank" class="baike-wrap">详情&gt;&gt;</a>
              </div>
            </div>
          </div>
          <a :href="toBrandSeriesInfo(item)" target="_blank" class="more-btn">查看车系</a>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "RelatedBrand",
  props: {
    list: {
      type:Array,
      default: () => ([])
    }
  },
  data() {
    return {
      totalHeight: 370,
      pageSize: 3,
      defaultLogoImage: 'https://www1.pcauto.com.cn/zt/new-kuai-sou/app/images/icon-logo-photo-default.png'
    }
  },
  computed: {
    titleUrl() {
      return 'https://price.pcauto.com.cn/cars/'
    },
    // 滑动卡片高度
    carouselHeight() {
      const singleHeight = parseFloat(this.totalHeight / this.pageSize).toFixed(2)
      if (this.list.length <= this.pageSize) {
        return `${singleHeight * this.list.length}px`
      } else {
        return `${this.totalHeight}px`
      }
    },
    // 是否显示指示器
    isShowIndicator() {
      if (this.pageItems.length > 1) {
        return ''
      } else {
        return 'none'
      }
    },
    // 是否显示切换
    isShowToggle() {
      if (this.pageItems.length > 1) {
        return 'hover'
      } else {
        return 'never'
      }
    },
    pageItems() {
      const totalItems = this.list
      const total = totalItems.length
      const pageCount = Math.ceil(total / this.pageSize)
      let pageItems = Array(pageCount).fill()
      pageItems = pageItems.map((m, n) => {
        let startIndex = n * this.pageSize
        let endIndex = startIndex + this.pageSize
        if (n === pageCount - 1) {
          endIndex = total
        }
        return {
          items: totalItems.slice(startIndex, endIndex)
        }
      })
      return pageItems
    }
  },
  methods: {
    // 查看品牌下车系
    toBrandSeriesInfo(item) {
      let url = item.url.replace('//auto-serial-list/', '//brand-serials/')
      const brandId = item.id || url.replace(/pcautobrowser:\/\/brand-serials\/(.*?)/g, '')
      return `https://price.pcauto.com.cn/price/nb${brandId}/#ad=15328`
    }
  }
};
</script>

<style lang="scss" scoped>
.related-brand {
  margin-bottom: 25px;
  .cxStrong {
    font-weight: normal;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    a {
      cursor: pointer;
      text-decoration: underline;
      color: #225599;            
    }
    em {
      color: #cc0000;
      text-decoration: underline;
      font-style: normal;
    }
  }
  &::v-deep .el-carousel__indicator button {
    background: #BFC3C8;
    width: 7px;
    height: 7px;
    border-radius: 50%;
  }
  &::v-deep .el-carousel__indicator.is-active button {
    width: 30px;
    border-radius: 20px;
    background: #0E60D5;
  }
  .swipe-list {
    .cell {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid #f0f0f0;
      border-left: 1px solid #f0f0f0;
      border-right: 1px solid #f0f0f0;
      padding: 10px 15px 10px 6px;
      &:last-child {
        border-bottom: 1px solid #f0f0f0;
      }
      .cell-l {
        display: flex;
        align-items: center;
        margin-right: 20px;
        .logo {
          width: 88px;
          height: 88px;
          flex-shrink: 0;
          margin-right: 11px;
        }
        .content {
          font-size: 12px;
          line-height: 1;
          .name {
            font-size: 16px;
            font-weight: bold;
            color: #0E60D5;
            &:hover {
              color: #fb6523 !important;
            }
          }
          .inner-wrap {
            display: flex;
            align-items: flex-end;
            .desc {
              color: #333;
              line-height: 1.5;
              margin-top: 15px;
              @include ellipsis(2);
            }
            .baike-wrap {
              flex-shrink: 0;
              color: #259;
              margin-bottom: 3px;
              &:hover {
                text-decoration: underline;
                color: #ff6600;
              }
            }
          }
        }
      }
      .more-btn {
        font-size: 14px;
        color: #fff;
        background: #0E60D5;
        padding: 9px 10px;
        border-radius: 4px;
        flex-shrink: 0;
        cursor: pointer;
      }
    }
  }
}
</style>
